import React from 'react';
import { Provider } from 'react-redux';

import AppLayout from './containers/AppLayout';
import store from './store';

/**
 * Main component of NudgeUI application.
 * @param {*} props 
 * @returns 
 */
const App = props => {
  return (
    <Provider store={store}>
      <AppLayout {...props} />
    </Provider>
  );
};

export default App;
